import React, { useState } from "react";
import ClipLoader from "react-spinners/ClipLoader";
const override: CSSProperties = {
  display: "block",
  margin: "0 auto",
  borderColor: "red",
};
const Loader = ({ color }) => {
  return (
    <div className="loader_component_container">
      <ClipLoader
        color={color ? color : "red"}
        loading={true}
        cssOverride={override}
        size={50}
      />
    </div>
  );
};

export default Loader;
